import orderOject from './order-object';

type TObject = Record<string, any>;

const objectEquality = (obj1: TObject, obj2: TObject): boolean =>
  JSON.stringify(orderOject(obj1)) === JSON.stringify(orderOject(obj2));

export default objectEquality;
